module.exports = __webpack_public_path__ + "media/images/undraw/shift/meet_the_team-dfb642d0ba8c2c7b5dc0babef94a37fd.png";